export default __webpack_public_path__ + "static/media/resturant-menu-theme-1.c1fa757d.jpg";